export default __webpack_public_path__ + "static/media/016-organizing.e25f3800.png";